import { render, staticRenderFns } from "./IcoStamp.vue?vue&type=template&id=1ec03c39"
import script from "./IcoStamp.vue?vue&type=script&lang=js"
export * from "./IcoStamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports